import { render, staticRenderFns } from "./ApprovalDone.vue?vue&type=template&id=54259fd4&scoped=true&"
import script from "./ApprovalDone.vue?vue&type=script&lang=js&"
export * from "./ApprovalDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54259fd4",
  null
  
)

export default component.exports